export const headcountHistory = [
  {
    "month": "2024-02",
    "total": 22,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 1,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 2,
      "Finance & Legal": 1,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 2,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-03",
    "total": 23,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 1,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 2,
      "Finance & Legal": 1,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 3,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-04",
    "total": 23,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 1,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 2,
      "Finance & Legal": 1,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 3,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-05",
    "total": 24,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 2,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 2,
      "Finance & Legal": 1,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 3,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-06",
    "total": 25,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 2,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 3,
      "Finance & Legal": 1,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 3,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-07",
    "total": 26,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 2,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 4,
      "Finance & Legal": 1,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 3,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-08",
    "total": 26,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 2,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 4,
      "Finance & Legal": 1,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 3,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-09",
    "total": 28,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 2,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 5,
      "Finance & Legal": 2,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 3,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-10",
    "total": 29,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 3,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 5,
      "Finance & Legal": 2,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 3,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-11",
    "total": 30,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 3,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 5,
      "Finance & Legal": 2,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 4,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2024-12",
    "total": 30,
    "departments": {
      "Clinical & Regulatory": 1,
      "Design": 1,
      "Design Control & Testing": 3,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 5,
      "Finance & Legal": 2,
      "IP": 1,
      "Machine Shop & Metrology": 3,
      "Mechanical Design": 4,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2025-01",
    "total": 34,
    "departments": {
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 6,
      "Finance & Legal": 2,
      "IP": 1,
      "Machine Shop & Metrology": 4,
      "Mechanical Design": 4,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2025-02",
    "total": 35,
    "departments": {
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 6,
      "Finance & Legal": 2,
      "IP": 1,
      "Machine Shop & Metrology": 5,
      "Mechanical Design": 4,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2025-03",
    "total": 39,
    "departments": {
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 7,
      "Finance & Legal": 3,
      "IP": 1,
      "Machine Shop & Metrology": 5,
      "Mechanical Design": 6,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2025-04",
    "total": 42,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 3,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 7,
      "Finance & Legal": 3,
      "IP": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 6,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2025-05",
    "total": 45,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 4,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 7,
      "Finance & Legal": 3,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 7,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2025-06",
    "total": 45,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 4,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 7,
      "Finance & Legal": 3,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 7,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 1
    }
  },
  {
    "month": "2025-07",
    "total": 48,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 6,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 7,
      "Finance & Legal": 3,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 7,
      "Mechanical R&D": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 2
    }
  },
  {
    "month": "2025-08",
    "total": 47,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 5,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 7,
      "Finance & Legal": 3,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 8,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 2
    }
  },
  {
    "month": "2025-09",
    "total": 47,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 5,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 7,
      "Finance & Legal": 3,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 8,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 2
    }
  },
  {
    "month": "2025-10",
    "total": 46,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 5,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 6,
      "Finance & Legal": 3,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 8,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 2
    }
  },
  {
    "month": "2025-11",
    "total": 46,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 1,
      "Design Control & Testing": 4,
      "Electrical & Software": 5,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 6,
      "Finance & Legal": 3,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 8,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 2
    }
  },
  {
    "month": "2025-12",
    "total": 49,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 2,
      "Design Control & Testing": 4,
      "Electrical & Software": 7,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 6,
      "Finance & Legal": 2,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 8,
      "Operations": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 2
    }
  },
  {
    "month": "2026-01",
    "total": 50,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 2,
      "Design Control & Testing": 4,
      "Electrical & Software": 7,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 6,
      "Finance & Legal": 2,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 7,
      "Mechanical Design": 8,
      "Operations": 1,
      "People & Culture": 1,
      "Demo Medical": 1,
      "Quality": 1,
      "Supply Chain": 2
    }
  },
  {
    "month": "2026-02",
    "total": 54,
    "departments": {
      "Cleanroom": 1,
      "Clinical & Regulatory": 2,
      "Design": 2,
      "Design Control & Testing": 4,
      "Electrical & Software": 7,
      "Engineering": 2,
      "Executive": 1,
      "Facilities": 6,
      "Finance & Legal": 3,
      "IP": 1,
      "IT": 1,
      "Machine Shop & Metrology": 8,
      "Mechanical Design": 8,
      "Operations": 1,
      "People & Culture": 2,
      "Demo Medical": 1,
      "Quality": 2,
      "Supply Chain": 2
    }
  }
];

export const departureHistory = [
  {
    "month": "2025-05",
    "count": 1,
    "people": [
      {
        "name": "Jamie W.",
        "dept": "Machine Shop & Metrology"
      }
    ]
  },
  {
    "month": "2025-06",
    "count": 1,
    "people": [
      {
        "name": "Morgan T.",
        "dept": "Machine Shop & Metrology"
      }
    ]
  },
  {
    "month": "2025-08",
    "count": 3,
    "people": [
      {
        "name": "Devon R.",
        "dept": "Electrical & Software"
      },
      {
        "name": "Jamie W.",
        "dept": "Mechanical R&D"
      },
      {
        "name": "Morgan T.",
        "dept": "Finance & Legal"
      }
    ]
  },
  {
    "month": "2025-10",
    "count": 1,
    "people": [
      {
        "name": "Devon R.",
        "dept": "Facilities"
      }
    ]
  },
  {
    "month": "2025-12",
    "count": 1,
    "people": [
      {
        "name": "Jamie W.",
        "dept": "Finance & Legal"
      }
    ]
  },
  {
    "month": "2026-02",
    "count": 1,
    "people": [
      {
        "name": "Morgan T.",
        "dept": "Electrical & Software"
      }
    ]
  }
];

export const departmentList = ["Cleanroom", "Clinical & Regulatory", "Design", "Design Control & Testing", "Electrical & Software", "Engineering", "Executive", "Facilities", "Finance & Legal", "IP", "IT", "Machine Shop & Metrology", "Mechanical Design", "Mechanical R&D", "Operations", "People & Culture", "Demo Medical", "Quality", "Supply Chain"];
